module.exports = __webpack_public_path__ + "static/img/4dx.4ca6bfb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/4dx.svg
// module id = 540
// module chunks = 1